<template>
    <v-app id="inspire">
        <v-main>
            <v-container fluid fill-height>
                <v-layout align-center justify-center>
                    <v-flex xs12 sm8 md4 style="max-width:500px; max-height: 600px;">
                        <v-card class="elevation-12 card" style="border: 10px solid #05523E;">
                            <v-icon size=30 @click="$router.go(-1)" style="position: absolute; left: 20px; top: 20px; color: #05523E;">mdi-arrow-left-thick</v-icon>
                            <div style="padding: 60px;">
                                <div style="font-size: 40px; font-weight: bold; color: #05523E; margin: 20px auto;"
                                >Forgot Account</div>
                                <div style="color:#929292; font-size: 18px; font-weight: 500; margin-bottom: 35px;" >CHOOSE WHAT YOU WANT TO FIND.</div>
                                <v-btn
                                  class="elevation-0 buttons"
                                  color="#ffffff"
                                  style="width: 100%; height: 80px; font-size: 20px; font-weight: bold; border: 3px solid #05523E; color: #05523E;"
                                  @click="findId()"
                                >
                                  FIND ID
                                </v-btn>
                                <v-btn
                                  fontColor
                                  class=" elevation-0 buttons"
                                  color="#ffffff"
                                  style="width: 100%; height: 80px; font-size: 20px; font-weight: bold; border: 3px solid #05523E; color: #05523E; margin: 20px auto;"
                                  @click="findPassword()"
                                >
                                  FIND PASSWORD
                                </v-btn>
                            </div>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
export default {
    data() {
        return {
            id : "",
            password : "",
            show: false,
            rules: {
                required: value => !!value || "Required.",
            },
        }
    },
    methods: {
        async findId() {
            try {
                this.$router.push({name: "FindId"});
            } catch (err) {
                console.error("findId" + err);
            }
        },
        async findPassword() {
            try {
                this.$router.push({name: "FindPw"});
            } catch (err) {
                console.error("findPassword" + err);
            }
        },
    },
}
</script>